import TischoffensivesDb from '../store/TischoffensivesStore';
import { fetchFromJson } from './fetchFromJson';

const db = new TischoffensivesDb('tischoffensivesDb');

const updateCache = 'tischOffensive_updateCache';
const getUpdateCache = (data) => data.sales_packages;
const toast = 'Tischoffensives Updated';
const entityName = 'tischOffensives';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
